/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveMerchantTokenRequest": {
                "fields": {
                  "finplatCustomerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveMerchantTokenResponse": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveMerchantTokenRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveMerchantTokenResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveMerchantTokenRequest @ squareup/corporate_card/service/retrieve_merchant_token.proto at 8:1
 */
export const RetrieveMerchantTokenRequest = $root.lookupType('squareup.corporate_card.service.RetrieveMerchantTokenRequest');
fixType(RetrieveMerchantTokenRequest);
Builder.createAndAttachToType(RetrieveMerchantTokenRequest);
/**
 * SOURCE RetrieveMerchantTokenResponse @ squareup/corporate_card/service/retrieve_merchant_token.proto at 15:1
 */
export const RetrieveMerchantTokenResponse = $root.lookupType('squareup.corporate_card.service.RetrieveMerchantTokenResponse');
fixType(RetrieveMerchantTokenResponse);
Builder.createAndAttachToType(RetrieveMerchantTokenResponse);